import React from 'react';
import './LegalPage.css';
import './SetupGuide.css';

function SetupGuide() {
  return (
    <div className="legal-page-container">
      <div className="legal-page-card setup-guide-card">
        <div className="logo-container">
          <img src="/acta-logo.jpg" alt="Acta Extension" className="acta-logo" />
        </div>
        <h1>Acta Extension Setup Guide</h1>

        <div className="legal-content">
          <div className="setup-overview">
            <p>Acta Extension connects HubSpot and Slack, allowing you to view, send, and sync Slack messages directly from your HubSpot CRM. Follow the steps below to get started.</p>
          </div>

          <h2>Step 1: Install the App from HubSpot Marketplace</h2>
          <div className="setup-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <p>Search for <strong>"Acta Extension"</strong> on the HubSpot App Marketplace and click <strong>"Install app"</strong>.</p>
              <p>Log in to your HubSpot account, review the required permissions, and click <strong>"Connect app"</strong> to authorize the installation.</p>
            </div>
          </div>

          <h2>Step 2: Complete the Registration Form</h2>
          <div className="setup-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <p>After installation, you will be redirected to the <strong>Acta Extension registration form</strong>.</p>
              <p>Fill in the required information:</p>
              <ul>
                <li><strong>Company name</strong>, <strong>name</strong>, <strong>email</strong>, and <strong>phone number</strong></li>
                <li><strong>HubSpot Portal ID (Hub ID)</strong> — found in your HubSpot settings under Account & Setup &gt; Account Defaults</li>
                <li><strong>Subscription plan</strong> — select the Free plan to start with a 14-day trial</li>
              </ul>
              <p>Review and agree to the <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="/terms-of-service" target="_blank" rel="noopener noreferrer">Terms of Service</a>, then submit the form.</p>
            </div>
          </div>

          <h2>Step 3: Set Up Your Password</h2>
          <div className="setup-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <p>After submitting the registration form, you will receive a <strong>password setup email</strong> at the email address you provided.</p>
              <p>Click the link in the email to set your admin account password. This account gives you access to the Acta admin dashboard where you can manage users and subscriptions.</p>
            </div>
          </div>

          <h2>Step 4: Authenticate with Slack</h2>
          <div className="setup-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <p>Open the Acta Extension from within HubSpot. You will be prompted to sign in with Slack.</p>
              <p>Click <strong>"Sign in with Slack"</strong>, select the workspace you want to connect, and authorize access. Once authenticated, your Slack channels and messages will appear.</p>
            </div>
          </div>

          <h2>Step 5: Connect HubSpot &amp; Enable Sync</h2>
          <div className="setup-step">
            <div className="step-number">5</div>
            <div className="step-content">
              <p>After Slack authentication, click <strong>"Connect HubSpot"</strong> to authorize the timeline sync integration. This allows Slack messages to be recorded on your HubSpot contact timeline.</p>
              <p>Then toggle <strong>"Sync to HubSpot"</strong> in the top-right corner to start syncing messages automatically.</p>
            </div>
          </div>

          <h2>Key Features</h2>
          <div className="feature-list">
            <div className="feature-item">
              <span className="feature-icon">💬</span>
              <div>
                <strong>View & Send Slack Messages</strong>
                <p>Access public and private Slack channels directly from HubSpot. Send, edit, and delete messages without leaving your CRM.</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🔄</span>
              <div>
                <strong>Auto-Sync to HubSpot Timeline</strong>
                <p>Automatically record Slack messages as notes on your contact timeline to streamline sales activity logging.</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🏢</span>
              <div>
                <strong>Multi-Workspace Support</strong>
                <p>Connect multiple Slack workspaces and switch between them seamlessly.</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon">⚡</span>
              <div>
                <strong>Real-Time Updates</strong>
                <p>Receive new messages, reactions, and thread replies in real time.</p>
              </div>
            </div>
          </div>

          <h2>Pricing</h2>
          <div className="pricing-info">
            <div className="plan-card">
              <h3>Free Plan</h3>
              <p className="plan-price">Free for 14 days</p>
              <p>Try all features free for 14 days. One trial per Hub ID.</p>
            </div>
            <div className="plan-card">
              <h3>Standard Plan</h3>
              <p className="plan-price">&#165;500 / user / month (excl. tax)</p>
              <p>Full access to all features. Billed monthly with auto-renewal.</p>
            </div>
          </div>

          <h2>Requirements</h2>
          <ul>
            <li>An active HubSpot account</li>
            <li>An active Slack account and workspace</li>
            <li>A modern browser (latest version of Chrome, Firefox, Safari, or Edge)</li>
          </ul>

          <h2>Support</h2>
          <div className="contact-info">
            <p><strong>Now Village Inc.</strong></p>
            <p>Email: kanri@now-village.jp</p>
            <p>Address: 2F Akasaka Hinoki Building, 2-10-5 Akasaka, Minato-ku, Tokyo, Japan</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SetupGuide;
